import "../../scss/client/client.scss";

import $ from "jquery";
// import "../../../node_modules/jquery-mobile/build/release";

/* ---------------------------------- UTILS --------------------------------- */
import "./utils/functions";
import "./utils/smoothscroll";
import "./utils/inject-css";

/* --------------------------------- SCRIPTS -------------------------------- */
import "./scripts/svg-lazy";
import "./scripts/photoswipe";
import "./scripts/page";
import "./scripts/navigation";
import "./scripts/swipe-stepper";
import "./scripts/tooltips-rotate";
import "./scripts/loader.js";

import { Generator } from "./modules/generator/generator";

export const componentsToRender = [
  {
    Component: <Generator />,
    selector: ".id-generator-app",
  },
];

const $window = $(window);

window.addEventListener("load", () => {
  componentsToRender.forEach(({ Component, selector }) => {
    const containers = document.querySelectorAll(selector);

    if (containers) {
      containers.forEach((container) => {
        const props = JSON.parse(container.getAttribute("data-props"));
        const ComponentToRender = React.cloneElement(Component, props);
        ReactDOM.render(ComponentToRender, container, () => $window.trigger('reactRender:done'));
      });
    }
  });
});
